import React, { useEffect, useState } from "react";
import Loginimg from "../assets/images/Loginimg.png";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import googliconimg from "../assets/images/Googleicon.png";
import ven1 from "../assets/images/ven1.gif";
import ven2 from "../assets/images/ven2.png";
import ven3 from "../assets/images/ven3.png";
import {  useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { auth, googleProvider, signInWithPopup, RecaptchaVerifier, signInWithPhoneNumber } from '../firebase/firebase.js';
import axios from 'axios';
import { GoogleAuthProvider } from "firebase/auth";
import API_BASE_URL from "../config.js";
import { Alert } from "react-bootstrap";
const LoginModal = (props) => {
    const navigate = useNavigate();
    const { loginModalshow, setLoginModalshow } = props;
    const [verifyModalshow, setVerifyModalshow] = useState(false);
    const [bookingformshow, setBookingformshow] = useState(false);
    const [show, setShow] = useState(false);
    const UIDData = localStorage.getItem('uid');
    const handleClose = () => setShow(false);
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    const [phone, setPhone] = useState('');
    const [otp, setOtp] = useState('');
    const [sentOtp, setSentOtp] = useState(null);
    const [phoneError, setPhoneError] = useState('');
    const [timeLeft, setTimeLeft] = useState(0); // Timer state
    const [isCounting, setIsCounting] = useState(false); // To track countdown state

    const closeloginmodal = () => {
        setLoginModalshow(false);
        document.body.style.overflow = 'auto';
        if (!UIDData) {
            setBookingformshow(false);
            setVerifyModalshow(false);
        }
        setSelectedCar('Maruti Suzuki Dezire');
    };

    const [selectedCar, setSelectedCar] = useState('Maruti Suzuki Dezire');

    const handleCarSelect = (carName) => {
        setSelectedCar(carName);
    };

    console.log("handleCarSelect", selectedCar)
    const handleGoogleLogin = async () => {
        debugger
        const provider = new GoogleAuthProvider();
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const token = await user.getIdToken();

            if (typeof window !== 'undefined' && token) {
                localStorage.setItem('accessToken', token);

            }

            const userData = {
                firebase_uid: user.uid,
                email: user.email || '',
                display_name: user.displayName || '',
                photo_url: user.photoURL || '',
                phone_number: user.phoneNumber || ''
            };

            const response = await axios.post(`${API_BASE_URL}/api/users`, userData);

            if (response.status === 200 && response.data) {
                const newUserData = {
                    ...userData,
                    userId: response.data?.user.id
                };

                setUserData(newUserData);
                localStorage.setItem('uid', btoa(newUserData.userId));
                localStorage.setItem('userData', btoa(JSON.stringify(response.data?.user)));
                setError(null);
                setLoginModalshow(false);
                document.body.style.overflow = 'auto';
                navigate('/profile');
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (e) {
            console.error('Sign-in Error:', e);
            setError('Failed to sign in with Google. Please try again.');
        }
    };

    const setupRecaptcha = () => {
        window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
            size: 'invisible',
        });
    };

    const validatePhoneNumber = (number) => {
        const phoneRegex = /^[6-9][0-9]{9}$/; // Starts with 6-9, followed by 9 digits
        return phoneRegex.test(number);
    };

    const handleSendOtp = async () => {
        setPhoneError(''); // Reset error message
        if (!validatePhoneNumber(phone)) {
            setPhoneError('Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.');
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/api/users/send-otp`, {
                phone_number: phone
            });
            if (response.data.message.includes('OTP sent')) {
                setSentOtp(response.data.otp);
                setPhone(phone);
                setVerifyModalshow(true);
                setTimeLeft(30);
                setIsCounting(true);
            }
        } catch (error) {
            console.error('OTP Send Error:', error);
            setPhoneError('Failed to send OTP. Please try again.');
        }
    };

    const handleVerifyOtp = async () => {
        debugger
        try {
            const response = await axios.post(`${API_BASE_URL}/api/users/verify-otp`, {
                phone_number: phone,
                otp
            });
            const userData = {
                mobileNumber: phone || '',
                otp
            };
            if (response.data && response.data.message === 'OTP verified successfully') {

                if (response.data) {
                    let newUserData = {
                        ...(userData || {}),
                        userId: response.data?.user.id
                    };

                    if (newUserData.userId) {
                        localStorage.setItem('userData', btoa(JSON.stringify(response.data?.user)));
                        localStorage.setItem('uid', btoa(newUserData.userId));
                    }

                    setUserData(newUserData);
                    setError(null);
                    navigate('/profile');
                } else {
                    setError('Verification successful, but user data is missing.');
                }

                setBookingformshow(true);
            } else {
                setError(response.data?.error || 'Invalid OTP');
            }
        } catch (error) {

            setError('Failed to verify OTP. Please try again.');
        }
    };

    const changeNo = () => {
        setPhone('');
        setOtp('');
        setPhoneError('');
        setVerifyModalshow(false);
        setBookingformshow(false);
    }

    useEffect(() => {
        let timer;
        if (isCounting && timeLeft > 0) {
            timer = setTimeout(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
        } else if (timeLeft === 0) {
            setIsCounting(false);
        }
        return () => clearTimeout(timer);
    }, [timeLeft, isCounting]);

    useEffect(() => {
        if (UIDData) {
            setBookingformshow(true);
            setVerifyModalshow(false);
            setLoginModalshow(false);
        }
    }, [UIDData]);


    const [formData, setFormData] = useState({
        user_id: atob(UIDData),
        name: "",
        mobileno: "",
        email: "",
        fromdate: "",
        todate: "",
    });

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState("");
    const [errorbook, setErrorbook] = useState("");

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    const handleSubmit = async (e) => {
        debugger
        e.preventDefault();
        setSuccess("");
        setErrorbook("");
        let validationErrors = {};

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const fromDate = new Date(formData.fromdate);
        const toDate = new Date(formData.todate);

        if (!formData.name.trim()) {
            validationErrors.name = "Full Name is required.";
        }

        if (!validatePhoneNumber(formData.mobileno)) {
            validationErrors.mobileno = "Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.";
        }

        if (!emailRegex.test(formData.email)) {
            validationErrors.email = "Enter a valid email address.";
        }

        if (!formData.fromdate) {
            validationErrors.fromdate = "Booking start date is required.";
        } else if (fromDate < today) {
            validationErrors.fromdate = "Booking start date cannot be in the past.";
        }

        if (!formData.todate) {
            validationErrors.todate = "Booking end date is required.";
        } else if (toDate < fromDate) {
            validationErrors.todate = "Booking end date cannot be before the start date.";
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const updatefrom = {
            ...formData, package: selectedCar
        }
        try {
            const response = await axios.post(`${API_BASE_URL}/api/enquiry`, updatefrom);

            if (response.status === 200) {
                setSuccess(response.data.message);
                closeloginmodal();
                setSuccess("");
                setSelectedCar("Maruti Suzuki Dezire");
                setShow(true);
                setFormData({ name: "", mobileno: "", email: "", fromdate: "", todate: "" });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setErrorbook(error.response?.data?.error || "Something went wrong");
        }
    };


    return (
        <>
            <div className={loginModalshow ? "overlayLoginModal d-block" : "overlayLoginModal"}></div>
            <div className={loginModalshow ? "rightAuthModal show" : "rightAuthModal"}>
                <div className="authmodal">
                    <img className="authimg" src={Loginimg} alt="Login" />
                    <div className="AuthcloseIcon" onClick={closeloginmodal}><i className="bi bi-x-circle-fill"></i></div>
                    <div className="loginbannerCOntent">
                        <h4>Welcome to Vrruksh Travels</h4>
                        <p>You have selected “Maruti Suzuki Dezire” as your car for rent booking enquiry.</p>

                        <div className="d-flex">
                            <div
                                className={`logincarbox ${selectedCar === 'Maruti Suzuki Dezire' ? 'active' : ''}`}
                                onClick={() => handleCarSelect('Maruti Suzuki Dezire')}>
                                <img src={ven1} alt="Maruti Suzuki Dezire" />
                                <p>Maruti Suzuki Dezire</p>
                            </div>

                            <div
                                className={`logincarbox ${selectedCar === 'Toyota Innova Crysta' ? 'active' : ''}`}
                                onClick={() => handleCarSelect('Toyota Innova Crysta')}>
                                <img src={ven2} alt="Toyota Innova Crysta" />
                                <p>Toyota Innova Crysta</p>
                            </div>

                            <div
                                className={`logincarbox ${selectedCar === 'Mahindra Scorpio S11 MT' ? 'active' : ''}`}
                                onClick={() => handleCarSelect('Mahindra Scorpio S11 MT')}>
                                <img src={ven3} alt="Mahindra Scorpio S11 MT" />
                                <p>Mahindra Scorpio S11 MT</p>
                            </div>
                        </div>

                    </div>
                </div>
                {!verifyModalshow && !bookingformshow && <div className="Authcontente">
                    <h4>Booking Enquiry Form</h4>
                    <p>Login/ Register to complete your booking  enquiry. This will help us communicate and  share booking invoice with you. You can manage all your booking from one place.</p>

                    <Form.Group className="mb-3" >
                        <Form.Label className="text-dark">* Mobile Number</Form.Label>
                        <div className="formlogininput" >
                            <span className="leftinput" > +91</span>
                            <Form.Control
                                type="number"
                                size="lg"
                                className="logininput"
                                placeholder="Enter your mobile number"
                                name="mobileno"
                                pattern="[6-9][0-9]{9}"
                                maxLength="10"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div>
                        <div>{phoneError && <Form.Text className="text-danger">{phoneError}</Form.Text>}</div>
                        <Form.Text className="text-muted">
                            We ask your mobile phone number so we can send an SMS text or WhatsApp message as a back up to email. (We won't call you unless you ask us to!)
                        </Form.Text>
                    </Form.Group>
                    <Button className="bookcombtn w-100 mt-0" onClick={handleSendOtp}> Send OTP</Button>


                    <div className="Orbtn">
                        <p>OR</p>
                    </div>
                    <div className="loginGoogleBtn" onClick={handleGoogleLogin}> <img src={googliconimg} alt="" className="me-2" /> Login with Google</div>
                    <div id="recaptcha-container"></div>
                </div>}

                {verifyModalshow && !bookingformshow &&
                    <div className="Authcontente">
                        <h4>Booking Enquiry Form</h4>
                        <p><span>Verify your mobile number using OTP. We have sent an SMS with 4-digits OTP on your mobile number +91 {phone}.</span>.  <button className="btnlink" onClick={changeNo}> ✎ CHANGE MOBILE NUMBER</button></p>
                        <Form.Group className="mb-3" >
                            <Form.Label>* OTP</Form.Label>
                            <div className="formlogininput" >
                                <Form.Control
                                    type="number"
                                    size="lg"
                                    className="logininput"
                                    placeholder="Enter 4-digit OTP"
                                    value={otp}
                                    maxLength="4"
                                    onChange={(e) => setOtp(e.target.value)}
                                />
                            </div>
                            <div>{error && <Form.Text className="text-danger">{error}</Form.Text>}</div>
                        </Form.Group>
                        <Button className="bookcombtn w-100 mt-0 verifybtn" onClick={handleVerifyOtp} > Verify otp</Button>


                        {isCounting && <div className="timeverify">{`00:${timeLeft < 10 ? `0${timeLeft}` : timeLeft} sec`}</div>}

                        {!isCounting && (
                            <div className="loginGoogleBtn resentbtn" onClick={handleSendOtp} >
                                Didn’t get OTP? Resend OTP</div>
                        )}
                    </div>
                }

                {bookingformshow && <div className="Authcontente finalbookform">
                    <h4>Booking Enquiry Form</h4>
                    <p><span>Send us your details and requirements by submitting the form below and we will email you all the information that you need to book your trip.</span></p>

                    <Form onSubmit={handleSubmit}>
                        {errorbook && <Alert variant="danger">{errorbook}</Alert>}
                        {success && <Alert variant="success">{success}</Alert>}

                        <div className="row">
                            <div className="col-md-12">
                                <Form.Group className="mb-2">
                                    <Form.Label>* Full Name / Company Name</Form.Label>
                                    <div className="formlogininput" > <Form.Control
                                        type="text"
                                        name="name"
                                        size="lg"
                                        placeholder="Enter your full name"
                                        value={formData.name}
                                        className="logininput"
                                        onChange={handleChange}
                                        required
                                    />
                                    </div>
                                    {errors.name && <Form.Text className="text-danger">{errors.name}</Form.Text>}
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-2">
                                    <Form.Label>* Mobile Number</Form.Label>
                                    <div className="formlogininput" >
                                        <Form.Control
                                            type="text"
                                            name="mobileno"
                                            size="lg"
                                            placeholder="Enter your mobile number"
                                            value={formData.mobileno}
                                            onChange={handleChange}
                                            maxLength="10"
                                            className="logininput"
                                            required
                                        />
                                    </div>
                                    {errors.mobileno && <Form.Text className="text-danger">{errors.mobileno}</Form.Text>}
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-2">
                                    <Form.Label>* Email</Form.Label>
                                    <div className="formlogininput" >
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            size="lg"
                                            placeholder="Enter your email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="logininput"
                                            required
                                        />
                                    </div>
                                    {errors.email && <Form.Text className="text-danger">{errors.email}</Form.Text>}
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-2">
                                    <Form.Label>* Book car from</Form.Label>
                                    <div className="formlogininput" >
                                        <Form.Control
                                            type="date"
                                            name="fromdate"
                                            size="lg"
                                            value={formData.fromdate}
                                            onChange={handleChange}
                                            className="logininput"
                                            required
                                        />
                                    </div>
                                    {errors.fromdate && <Form.Text className="text-danger">{errors.fromdate}</Form.Text>}
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-2">
                                    <Form.Label>* Book car till</Form.Label>
                                    <div className="formlogininput" >
                                        <Form.Control
                                            type="date"
                                            name="todate"
                                            size="lg"
                                            value={formData.todate}
                                            onChange={handleChange}
                                            className="logininput"
                                            required
                                        />
                                    </div>
                                    {errors.todate && <Form.Text className="text-danger">{errors.todate}</Form.Text>}
                                </Form.Group>
                            </div>

                            <div className="col-md-12 mt-3">
                                <Button className="bookcombtn w-100 mt-0 " type="submit">Send</Button>
                            </div>
                        </div>
                    </Form>

                </div>
                }
            </div>
            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body>
                    <div className='text-center p-4'>
                        <h4>Submission Successful !</h4>
                        <p>Thank you for reaching out to us. We will get back to you soon!</p>
                        <Button variant="dark" className='mt-2' onClick={handleClose} style={{ width: "100px" }}>
                            CLOSE
                        </Button>
                    </div>
                </Modal.Body>

            </Modal>
        </>
    )
}
export default LoginModal